import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import cacheStorage from '../utils/cacheStorage';

function getRole() {
    const token = cacheStorage.getItem('id_token');
    if (!token) return null;

    try {
        const decoded = jwtDecode(token);
        return decoded['https://SmartCargo/roles']?.[0] || null;
    } catch (error) {
        console.error('Failed to decode token in ProtectedRoute:', error);
        return null;
    }
}

function isAdmin(role) {
    return role === 'admin' || role === 'master admin';
}

function isCourier(role) {
    return role === 'courier';
}

export default function ProtectedRoute({ allowedRoles }) {
    const location = useLocation();
    const accessToken = cacheStorage.getItem('access_token');
    const role = getRole();

    if (!accessToken || !role) {
        return <Navigate to="/" replace state={{ from: location.pathname }} />;
    }

    const allowed =
        allowedRoles.includes(role) ||
        (allowedRoles.includes('admin') && isAdmin(role)) ||
        (allowedRoles.includes('courier') && isCourier(role));

    if (!allowed) {
        return (
            <Navigate
                to="/access-denied"
                replace
                state={{ attemptedPath: location.pathname }}
            />
        );
    }

    return <Outlet />;
}